export default "__VITE_ASSET__MhBdHGFu__"